module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/right-circle-41e00cb59227b8fd0430339e89cec527.svg";